




















import { Vue, Component, Inject } from "vue-property-decorator";
import { IBasketProviderData } from "@/models/providers/baskets";
import { IAppliedTax } from "@/models/tax";
import { DataModules } from "@/store/modules/data";

@Component
export default class BasketTotals extends Vue {
  // Inject
  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;
  // Computed
  public get basketData() {
    return this.$basketData();
  }
  // Methods
  public getAppliedTaxTagName(tax: IAppliedTax) {
    return this.$store.getters[
      `data/${DataModules.TAX_TAGS}/computeAppliedTagName`
    ](tax.tax_tag_data?.[0]);
  }
}
